











import { Filter } from '@empathy/search-types';
import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { GETTERS_KEYS } from '../../../store';
import { GetFacetConfigByName } from '../../../store/config/getters/facet.getter';
import { FacetsGroupMixin } from '../../mixins/facets-group.mixin';

@Component({
  computed: {
    ...mapGetters({
      facetConfig: GETTERS_KEYS.config.facet
    })
  }
})
export default class GroupSelectedFilters extends Mixins(FacetsGroupMixin) {
  facetConfig: GetFacetConfigByName;

  getFilterTitleComponent(filter: Filter): string | null {
    return this.facetConfig(filter.facet.modelName, this.groupId).components.selectedFilters.filterTitle;
  }
}
